<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Ambis Meter',
                    to: { path: '/ambis-meter' },
                },
                { text: 'Leaderboard' },
            ]"
            divider=">"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">Leaderboard</h3>

        <v-card>
            <v-list-item two-line class="mx-5 my-5">
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kelas
                    </v-list-item-title>
                    <v-select
                        outlined
                        placeholder="Pilih Kelas"
                        v-model="kelas"
                        class="pa-0"
                        :items="listClass"
                        item-text="name"
                        item-value="id"
                        v-on:change="fetchData"
                    >
                        <template v-slot:selection="{ item }">
                            <v-list-item class="pa-0 ma-0">
                                <v-list-item-title>{{
                                    item.name
                                }}</v-list-item-title>
                            </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-list-item-title>{{
                                item.name
                            }}</v-list-item-title>
                        </template>
                    </v-select>
                </v-list-item-content>
            </v-list-item>
        </v-card>

        <v-card v-if="isShow">
            <v-card-title> Periode {{ periode_name }} </v-card-title>
            <v-divider />

            <app-datatable
                :items="ranks"
                :headers="headers"
                :key="tableKey"
                :custom-pagination-per-page="100"
                :custom-pagination-total-items="ranks.length"
                :custom-pagination-current-page="1"
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
    name: "leaderboard",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            search: "",
            tableKey: 0,
            isShow: false,
            ranks: [],
            periode_name: "",
            kelas: null,
            listClass: [
                { id: 1, name: "Kelas 1" },
                { id: 2, name: "Kelas 2" },
                { id: 3, name: "Kelas 3" },
                { id: 4, name: "Kelas 4" },
                { id: 5, name: "Kelas 5" },
                { id: 6, name: "Kelas 6" },
                { id: 7, name: "Kelas 7" },
                { id: 8, name: "Kelas 8" },
                { id: 9, name: "Kelas 9" },
                { id: 10, name: "Kelas 10" },
                { id: 11, name: "Kelas 11" },
                { id: 12, name: "Kelas 12" },
            ],
            headers: [
                { text: "Peringkat", value: "rank" },
                { text: "Nama", value: "user_name" },
                { text: "Sekolah", value: "sekolah" },
                { text: "Poin", value: "poin" },
            ],
            headersKey: ["rank", "user_name", "sekolah", "poin"],
        };
    },

    mounted: function () {
        // this.fetchData();
    },

    methods: {
        fetchData: function () {
            var context = this;
            this.ranks = [];
            this.periode_name = "";
            var periode_id = this.$route.query.id;

            AmbisMeterService.getLeaderboard(
                periode_id,
                context.kelas,
                (result) => {
                    if (result.success) {
                        context.periode_name = result.data.periode.name;
                        result.data.leaderboard.forEach(function (response) {
                            var row = {
                                rank: response.rank,
                                user_name: response.user_name,
                                sekolah: response.school,
                                poin: response.point,
                            };

                            context.ranks.push(row);
                            context.ranks = _.orderBy(
                                context.ranks,
                                "rank",
                                "asc",
                            );
                            context.isShow = true;
                            context.isLoading = false;
                        });
                    }
                    context.isLoading = false;
                },
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// Leaderboard.vue?3cd1a682